module.exports = function getResource(label, vars = []) {
    const resources = {
        curbsidePickupAvailable: 'Ramassage côté trottoir offert'
    };

    return resources[label];
};
